<template>
  <div class="card">
    <header v-if="title" class="card-header">
      <p class="card-header-title">
        <!-- <b-icon v-if="icon" :icon="icon" custom-size="default"/> -->
        {{ title }}
      </p>
      <div class="card-header">
        <p class="fill">
          Start: {{tankData[0].volume_left}}Ltr
        </p>
        <p class="fill">
          Current: {{tankData[tankData.length -1].volume_left}}Ltr
        </p>
        <p class="fill">
          Sales: {{tankData[0].volume_left - tankData[tankData.length -1].volume_left}}Ltr
        </p>
        <p class="fill">
          Revenue: {{(tankData[0].volume_left - tankData[tankData.length -1].volume_left) * 185}} Naira
        </p>
      </div>
      <div class="card-header">
        <!-- <p class="fill">Current</p> -->
        <p v-if="lastFilledTime === ''" class="fill">Last fill time: <span class="time">Empty</span> </p>
        <p v-else class="fill">Last fill time: <span class="time">{{ lastFilledTime }} hrs ago</span></p>
      </div>
      <a v-if="headerIcon" href="#" class="card-header-icon" aria-label="more options" @click.prevent="headerIconClick">
        <b-icon :icon="headerIcon" custom-size="default"/>
      </a>
    </header>
    <div class="card-content">
      <slot/>
    </div>
    <p v-if="title && tankData && tankData.length > 0" class="lab label"> <b>Volume Left</b> </p>
    <p v-if="title && tankData && tankData.length > 0"  class="label"> <b>Hour</b></p>
  </div>
</template>

<script>
export default {
  name: 'CardComponent',
  props: {
    title: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    headerIcon: {
      type: String,
      default: null
    },
    lastFilledTime: {
      type: Number,
      default: null
    },
    tankData: {
      type: Array,
      default: null
    }
  },

  methods: {
    headerIconClick() {
      this.$emit('header-icon-click');
    }
  }
};
</script>

<style scoped>
.fill {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
  color: #817F7F;
  margin-right: 20px;
}
.fill-time {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
  color: #000000;
}
.time {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
  color: #000000;
}
.lab {
  position: absolute;
  left: 2.5%;
  transform-origin: 0 0;
  transform: rotate(90deg);
  top: 0;
  width: 560px;
}
.card{
  align-content: center;
}
.chart-area {
  height: 100%;
  /* align-content: space-between; */
}
.card-content {
  max-height: 440px;
}
.label {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
  color: #817F7F;
  text-align: center;
}
@media screen and (max-width: 768px) {
  .lab {
    left: 5%;
  }
  .card-content{
    padding: 0.5rem
  }
}
</style>
